import React, { Component } from "react";

/**
 * PayTR Kart Bilgisi Formu
 *
 * Online ödeme için kart bilgilerini toplayan form component'i.
 * Validasyon ve formatlama özellikleri içerir.
 */
class PaytrCardForm extends Component {
  state = {
    cc_owner: "",
    card_number: "",
    expiry_month: "",
    expiry_year: "",
    cvv: "",
    installment_count: 0,
    errors: {},
  };

  /**
   * Kart numarasını formatla (4'lü gruplar)
   */
  formatCardNumber = (e) => {
    let value = e.target.value.replace(/\s/g, "").replace(/\D/g, "");
    if (value.length > 16) value = value.substr(0, 16);

    const formatted = value.match(/.{1,4}/g);
    this.setState({
      card_number: formatted ? formatted.join(" ") : value,
    });
  };

  /**
   * Input değişikliğini yönet
   */
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      errors: Object.assign({}, this.state.errors, { [e.target.name]: "" }),
    });
  };

  /**
   * Kart verilerini al ve validate et
   * @returns {Object|null} Validasyon başarılıysa kart verileri, başarısızsa null
   */
  getCardData = () => {
    const errors = {};

    // Kart sahibi kontrolü
    if (!this.state.cc_owner.trim()) {
      errors.cc_owner = "Kart sahibi adı gereklidir";
    }

    // Kart numarası kontrolü
    const cardNumber = this.state.card_number.replace(/\s/g, "");
    if (cardNumber.length !== 16) {
      errors.card_number = "Kart numarası 16 haneli olmalıdır";
    }

    // Ay kontrolü
    if (!this.state.expiry_month) {
      errors.expiry_month = "Ay seçiniz";
    }

    // Yıl kontrolü
    if (!this.state.expiry_year) {
      errors.expiry_year = "Yıl seçiniz";
    }

    // Son kullanma tarihi kontrolü (geçmiş tarihli kart engellenir)
    if (this.state.expiry_month && this.state.expiry_year) {
      const now = new Date();
      const selectedYear = 2000 + parseInt(this.state.expiry_year, 10);
      const selectedMonth = parseInt(this.state.expiry_month, 10);
      if (
        selectedYear < now.getFullYear() ||
        (selectedYear === now.getFullYear() &&
          selectedMonth < now.getMonth() + 1)
      ) {
        errors.expiry_year = "Kartınızın son kullanma tarihi geçmiş";
      }
    }

    // CVV kontrolü
    if (this.state.cvv.length !== 3) {
      errors.cvv = "CVV 3 haneli olmalıdır";
    }

    if (Object.keys(errors).length > 0) {
      this.setState({ errors: errors });
      return null;
    }

    return {
      cc_owner: this.state.cc_owner,
      card_number: cardNumber,
      expiry_month: this.state.expiry_month,
      expiry_year: this.state.expiry_year,
      cvv: this.state.cvv,
      installment_count: parseInt(this.state.installment_count) || 0,
    };
  };

  render() {
    const errors = this.state.errors;

    // Yıl listesi dinamik üretilir: içinde bulunulan yıldan itibaren 20 yıl.
    // Kartlar en fazla ~10 yıl geçerlilikle basıldığı için tüm kartları kapsar
    // ve her yıl otomatik güncellenir (elle güncelleme gerektirmez).
    const currentYear = new Date().getFullYear();
    const expiryYears = [];
    for (let i = 0; i <= 20; i++) {
      expiryYears.push(currentYear + i);
    }

    return (
      <div style={styles.formWrapper}>
        <div className="form-group">
          <label style={styles.label}>
            Kart Üzerindeki İsim <span style={styles.required}>*</span>
          </label>
          <input
            type="text"
            name="cc_owner"
            className={"form-control " + (errors.cc_owner ? "is-invalid" : "")}
            placeholder="Ad Soyad"
            maxLength="50"
            value={this.state.cc_owner}
            onChange={this.handleChange}
            style={styles.input}
          />
          {errors.cc_owner && (
            <div className="invalid-feedback">{errors.cc_owner}</div>
          )}
        </div>

        <div className="form-group">
          <label style={styles.label}>
            Kart Numarası <span style={styles.required}>*</span>
          </label>
          <input
            type="text"
            name="card_number"
            className={
              "form-control " + (errors.card_number ? "is-invalid" : "")
            }
            placeholder="1234 5678 9012 3456"
            value={this.state.card_number}
            onChange={this.formatCardNumber}
            style={styles.input}
          />
          {errors.card_number && (
            <div className="invalid-feedback">{errors.card_number}</div>
          )}
        </div>

        <div className="row">
          <div className="col-4">
            <label style={styles.label}>
              Ay <span style={styles.required}>*</span>
            </label>
            <select
              name="expiry_month"
              className={
                "form-control " + (errors.expiry_month ? "is-invalid" : "")
              }
              value={this.state.expiry_month}
              onChange={this.handleChange}
              style={styles.select}
            >
              <option value="">Ay</option>
              {Array.from({ length: 12 }, function (_, i) {
                return i + 1;
              }).map(function (m) {
                return (
                  <option key={m} value={m}>
                    {m}
                  </option>
                );
              })}
            </select>
            {errors.expiry_month && (
              <div className="invalid-feedback d-block">
                {errors.expiry_month}
              </div>
            )}
          </div>

          <div className="col-4">
            <label style={styles.label}>
              Yıl <span style={styles.required}>*</span>
            </label>
            <select
              name="expiry_year"
              className={
                "form-control " + (errors.expiry_year ? "is-invalid" : "")
              }
              value={this.state.expiry_year}
              onChange={this.handleChange}
              style={styles.select}
            >
              <option value="">Yıl</option>
              {expiryYears.map(function (fullYear) {
                // PayTR 2 haneli yıl bekler (örn: 2036 -> "36"),
                // kullanıcıya ise tam yıl gösterilir.
                return (
                  <option key={fullYear} value={String(fullYear).slice(-2)}>
                    {fullYear}
                  </option>
                );
              })}
            </select>
            {errors.expiry_year && (
              <div className="invalid-feedback d-block">
                {errors.expiry_year}
              </div>
            )}
          </div>

          <div className="col-4">
            <label style={styles.label}>
              CVV <span style={styles.required}>*</span>
            </label>
            <input
              type="password"
              name="cvv"
              className={"form-control " + (errors.cvv ? "is-invalid" : "")}
              placeholder="000"
              maxLength="3"
              value={this.state.cvv}
              onChange={this.handleChange}
              style={styles.input}
            />
            {errors.cvv && <div className="invalid-feedback">{errors.cvv}</div>}
          </div>
        </div>

        <div style={styles.installmentWrapper}>
          <div style={styles.installmentOption}>
            <input
              type="radio"
              id="installment-single"
              name="installment_count"
              value="0"
              checked={
                this.state.installment_count === 0 ||
                this.state.installment_count === "0"
              }
              onChange={this.handleChange}
              style={styles.radio}
            />
            <label htmlFor="installment-single" style={styles.installmentLabel}>
              Tek Çekim
            </label>
          </div>
        </div>
      </div>
    );
  }
}

const styles = {
  formWrapper: {
    marginTop: "15px",
    // padding: "20px",
    // backgroundColor: "#ffffff",
    // borderRadius: "12px",
    // border: "1px solid #e6eaf2",
  },
  label: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#4c566a",
    marginBottom: "8px",
    display: "block",
  },
  required: {
    color: "#dc3545",
  },
  input: {
    height: "44px",
    fontSize: "15px",
    borderColor: "#d9dee8",
    borderRadius: "8px",
    padding: "10px 14px",
  },
  select: {
    height: "44px",
    fontSize: "15px",
    borderColor: "#d9dee8",
    borderRadius: "8px",
    padding: "10px 14px",
  },
  installmentWrapper: {
    marginTop: "20px",
    padding: "16px",
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    border: "1px solid #e5e4e9",
  },
  installmentOption: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  radio: {
    width: "18px",
    height: "18px",
    cursor: "pointer",
    accentColor: "rgb(95, 141, 0)",
  },
  installmentLabel: {
    fontSize: "15px",
    fontWeight: "500",
    color: "#1a1d1f",
    margin: 0,
    cursor: "pointer",
  },
};

export default PaytrCardForm;



// WEBPACK FOOTER //
// ./src/components/PaytrCardForm.js